import Vue from 'vue'
import index from './index.vue'
import router from '@/router'
import store from '../../store/index'
import $utils from '../../utils/utils'

import '@/assets/styles/basic.scss'
import '@/assets/styles/global.scss'
import '@/assets/styles/atom.scss'

import directive from '@/utils/directive'
import Vtip from 'vtip'
import 'vtip/lib/index.min.css'

import Components from '@/components'

import { Modal, Radio, message, Anchor, FormModel, Input, Button, Table, Tabs, Badge, Icon, Dropdown, Spin } from 'ant-design-vue'
Vue.use(Modal)
Vue.use(Radio)
Vue.use(Anchor)
Vue.use(FormModel)
Vue.use(Input)
Vue.use(Button)
Vue.use(Table)
Vue.use(Tabs)
Vue.use(Badge)
Vue.use(Icon)
Vue.use(Dropdown)
Vue.use(Spin)
Vue.prototype.$message = message

directive.init(Vue)

Vue.config.productionTip = false
Vue.use(Components)
Vue.use(Vtip.directive)

Vue.use({
  install(Vue) {
    Vue.prototype.$toPage = function(val, obj) {
      if (typeof val === 'object') {
        obj = val
        val = this.$router.path
      }
      setTimeout(() => {
        this.$router.push({
          path: val,
          query: obj || {}
        })
      }, 0)
    }
  }
})
new Vue({
  router,
  store,
  render: h => h(index)
}).$mount('#app')

if ($utils.isMobile()) {
  // 初始化
  $utils.setRem()
  // 改变窗口大小时重新设置 rem
  window.onresize = function() {
    $utils.setRem()
  }
}
